import React, { useEffect } from 'react';
import DashboardLayout from '../components/Nav';
import SIPLogsTable from '../components/SIPLogsTable';

export default function SIPLogsPage() {
  useEffect(() => {
    document.title = "SIP Trace Logs | Voice Intelligence Portal";
  }, []);

  return (
    <DashboardLayout>
      <SIPLogsTable />
    </DashboardLayout>
  );
}



// import React, { useEffect, useState } from 'react';
// import DashboardLayout from '../components/Nav';
// import { RefreshCw, ExternalLink, Maximize2, Minimize2 } from "lucide-react";

// export default function SIPLogsPage() {
//   const [isFullscreen, setIsFullscreen] = useState(false);
//   const [iframeKey, setIframeKey] = useState(0);
//   const [isLoading, setIsLoading] = useState(true);

//   useEffect(() => {
//     document.title = "SIP Trace Logs | Voice Intelligence Portal";
//   }, []);

//   // Handle iframe load
//   const handleIframeLoad = () => {
//     setIsLoading(false);
//   };

//   // Refresh iframe
//   const refreshIframe = () => {
//     setIsLoading(true);
//     setIframeKey(prev => prev + 1);
//   };

//   // Toggle fullscreen
//   const toggleFullscreen = () => {
//     setIsFullscreen(!isFullscreen);
//   };

//   // Open in new tab
//   const openInNewTab = () => {
//     window.open("http://192.168.77.6:9080/", "_blank");
//   };

//   return (
//     <>
//       {isFullscreen ? (
//         <div className="fixed inset-0 z-50 bg-white">
//           {/* Fullscreen Header */}
//           <div className="p-4 border-b bg-gray-50">
//             <div className="flex items-center justify-between">
//               <h2 className="text-xl font-semibold text-gray-800">
//                 GoSoftLab SIP Log
//               </h2>
              
//               <div className="flex items-center space-x-2">
//                 <button
//                   onClick={refreshIframe}
//                   className="flex items-center space-x-2 px-3 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
//                   title="Refresh"
//                 >
//                   <RefreshCw className="w-4 h-4" />
//                   <span className="text-sm">Refresh</span>
//                 </button>



//                 <button
//                   onClick={toggleFullscreen}
//                   className="flex items-center space-x-2 px-3 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors"
//                   title="Exit Fullscreen"
//                 >
//                   <Minimize2 className="w-4 h-4" />
//                   <span className="text-sm">Exit</span>
//                 </button>
//               </div>
//             </div>

//             {isLoading && (
//               <div className="mt-2">
//                 <div className="flex items-center space-x-2 text-sm text-gray-600">
//                   <RefreshCw className="w-4 h-4 animate-spin" />
//                   <span>Loading GoSoftLab SIP Log...</span>
//                 </div>
//               </div>
//             )}
//           </div>

//           {/* Fullscreen Iframe */}
//           <div className="w-full h-[calc(100vh-80px)] overflow-hidden">
//             <iframe
//               key={iframeKey}
//               src="http://192.168.77.6:9080/"
//               title="GoSoftLab SIP Log"
//               className="w-full h-[calc(100%+80px)] border-0 -mt-[80px]"
//               onLoad={handleIframeLoad}
//               sandbox="allow-same-origin allow-scripts allow-forms allow-popups allow-modals"
//               allow="clipboard-read; clipboard-write"
//             />
//           </div>
//         </div>
//       ) : (
//         <DashboardLayout>
//           {/* Header */}
//           <div className="mb-4">
//             <div className="flex items-center justify-between">
//               <h2 className="text-2xl font-semibold text-gray-800">
//                 GoSoftLab SIP Log
//               </h2>
              
//               <div className="flex items-center space-x-2">
//                 <button
//                   onClick={refreshIframe}
//                   className="flex items-center space-x-2 px-3 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
//                   title="Refresh"
//                 >
//                   <RefreshCw className="w-4 h-4" />
//                   <span className="text-sm">Refresh</span>
//                 </button>



//                 <button
//                   onClick={toggleFullscreen}
//                   className="flex items-center space-x-2 px-3 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors"
//                   title="Fullscreen"
//                 >
//                   <Maximize2 className="w-4 h-4" />
//                   <span className="text-sm">Fullscreen</span>
//                 </button>
//               </div>
//             </div>

//             {isLoading && (
//               <div className="mt-2">
//                 <div className="flex items-center space-x-2 text-sm text-gray-600">
//                   <RefreshCw className="w-4 h-4 animate-spin" />
//                   <span>Loading GoSoftLab SIP Log...</span>
//                 </div>
//               </div>
//             )}
//           </div>

//           {/* Iframe Container */}
//           <div className="bg-white border rounded-xl shadow-lg overflow-hidden h-[calc(100vh-200px)]">
//             <iframe
//               key={iframeKey}
//               src="http://192.168.77.6:9080/"
//               title="GoSoftLab SIP Log"
//               className="w-full h-[calc(100%+80px)] border-0 -mt-[80px]"
//               onLoad={handleIframeLoad}
//               sandbox="allow-same-origin allow-scripts allow-forms allow-popups allow-modals"
//               allow="clipboard-read; clipboard-write"
//             />
//           </div>

//           <div className="mt-4 text-xs text-gray-500 text-center">
//             GoSoftLab SIP Log Interface - Use fullscreen for better experience
//           </div>
//         </DashboardLayout>
//       )}
//     </>
//   );
// }